import { MouseEvent } from "react";
import { useLocation } from "react-router-dom";

import ListItemAction from "ds/components/ListItemAction";
import { IconComponent } from "types/Icon";
import Tooltip from "ds/components/Tooltip";
import { checkIsActive } from "components/MainNavigation/helpers";
import { MainNavigationItemRouteRule } from "components/MainNavigation/types";

type MainNavigationMobileMenuItemProps = {
  ariaLabel: string;
  id?: string;
  to?: string;
  href?: string;
  icon: IconComponent;
  rule?: MainNavigationItemRouteRule;
  onClick?: (e: MouseEvent) => void;
  children?: React.ReactNode;
  className?: string;
};

const MainNavigationMobileMenuItem = ({
  id,
  children,
  to,
  href,
  icon,
  rule,
  onClick,
  className,
  ariaLabel,
}: MainNavigationMobileMenuItemProps) => {
  const location = useLocation();
  const isActive = checkIsActive(location.pathname, rule);

  return (
    <Tooltip
      disableAriaLabel
      active={false}
      placement="right"
      on={({ ref: tooltipRef, ...props }) => (
        <ListItemAction
          key={to}
          {...props}
          id={id}
          to={to}
          href={href}
          target={href ? "_blank" : undefined}
          icon={icon}
          iconSize="default"
          active={isActive}
          onClick={onClick}
          end
          isNavLink
          fullWidth
          innerRef={tooltipRef}
          className={className}
          aria-label={ariaLabel}
        >
          {children}
        </ListItemAction>
      )}
    >
      {children}
    </Tooltip>
  );
};

export default MainNavigationMobileMenuItem;
